import { render, staticRenderFns } from "./quillEditor.vue?vue&type=template&id=0620b729&"
import script from "./quillEditor.vue?vue&type=script&lang=js&"
export * from "./quillEditor.vue?vue&type=script&lang=js&"
import style0 from "./quillEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports